import { API_URL } from './../../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
    showErrorMessage
} from './../../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    showErrorMessage,
    extractDataFromObject, 
    API_URL,
};

export const GET_CURRICULUM_LIBRARIES_LIST_API = `${API_URL}/api/MasterCurriculumLibrary/GetMasterCurriculumLibrary`;
export const POST_CURRICULUM_LIBRARIES_API = `${API_URL}/api/MasterCurriculumLibrary/SaveMasterCurriculumLibrary`;
export const GET_CURRICULUM_LIBRARIES_DETAILS_API = `${API_URL}/api/MasterCurriculumLibrary/GetMasterCurriculumLibraryById`;
export const DELETE_CURRICULUM_LIBRARIES_API = `${API_URL}/api/MasterCurriculumLibrary/DeleteMasterCurriculumLibrary`;
export const POST_UPLOADCSVDOCUMENTSFORDC = `${API_URL}/api/MasterCurriculumLibrary/UploadCSVDocumentForDC`;
export const DOWNLOAD_SMAPLE_DOCUMENT = `${API_URL}/api/MasterCurriculumLibrary/DownloadSampleLibraryDocument`; // Download Sample Library Document
export const ARCHIVE_BATCH_DC_STATUS_API = `${API_URL}/api/MasterCurriculumLibrary/UpdateDCArchiveStatus`;
export const UNARCHIVE_BATCH_DC_STATUS_API = `${API_URL}/api/MasterCurriculumLibrary/UpdateDCBatchUnarchiveStatus`;

export const CurriculumLibrariesActionTypes = {
  get_curriculumLibrariesList: createRequestActionTypes('GET_CURRICULUMLIBRARIESLIST'),
  post_curriculumLibraries: createRequestActionTypes('POST_CURRICULUMLIBRARIES'),
  get_curriculumLibrariesDetails: createRequestActionTypes('GET_CURRICULUMLIBRARIESDETAILS'),
  delete_curriculumLibraries: createRequestActionTypes('DELETE_CURRICULUMLIBRARIES'),
  post_UploadCSVDocumentsForDC: createRequestActionTypes('POST_UPLOADCSVDOCUMENTSFORDC'),  
  download_sample_document: createRequestActionTypes('DOWNLOAD_SMAPLE_DOCUMENT'), // Uploaded document download
  archive_batchDCStatus: createRequestActionTypes('ARCHIVE_BATCH_DC_STATUS_API'),
};

export const MODULE = 'DCMASTER_CURRICULUMLIBRARY';





// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/constants/ApiConstants.js